import angular from 'angular';
import { RescisaoPontoService } from './rescisao.ponto.service';
import { ModalConfirmService } from '../../../../shared/components/modal-confirm/modal.confirm.service';
import { IEtapaPontoRescisao, ISaldoPontoRescisao } from './models/rescisao.ponto.service.model';
import {
    ChecklistItem,
    ChecklistStatus,
    RescisaoPontoEtapa,
    Step,
    StepHistory,
} from './models/rescisao.ponto.view.model';

export class RescisaoPontoController {

    static $inject = [
        '$scope',
        '$rootScope',
        'RescisaoPontoService',
        'ModalConfirmService',
        'NewToaster',
    ];

    public id: string;
    public currentStep: number;
    public hideActions: boolean;
    public wkfCodigoEstado: string | null;

    public step: Step | null;
    public stepHistory: StepHistory = this.createEmptyStepHistory();
    public label: {
        class: string;
        content: string
    };
    public checklistItems: ChecklistItem[] = [];
    public showRequestTreatmentAction = false;
    public showUnlockAction = false;
    public tag = {
        ajustes: 0,
        inconsistencias: 0,
    };

    public isBusy = false;
    public isBusyBtn = false;

    constructor(
        public $scope: angular.IScope,
        public $rootScope: angular.IRootScopeService & {
            nsjGlobals: { a: { url_pontoweb: string } }
        },
        public RescisaoPontoService: RescisaoPontoService,
        public ModalConfirmService: ModalConfirmService,
        public NewToaster: { pop: Function },
    ) {
        this.$scope.$watch('$ctrl.step', (newValue: Step, oldValue: Step) => {
            if (newValue && newValue !== oldValue) {
                this.currentStep = newValue.etapa;
                this.label = this.setLabel(newValue.etapa);
                this.syncChecklistState();
                if (this.shouldLoadSaldo(newValue.etapa)) {
                    this.RescisaoPontoService.getSaldo(this.id);
                }
            }
        }, true);
        this.$scope.$on('meurh_solicitacoesrescisaoetapas_busca_loaded', (event, args: IEtapaPontoRescisao[]) => {
            this.isBusy = false;
            if (Array.isArray(args) && args[0]) {
                this.stepHistory = this.setStepHistory(args);
                this.step = {
                    etapa: args[0].etapa,
                    etapadetalhe: args[0].etapadetalhe,
                };
            }
        });
        this.$scope.$on('meurh_solicitacoesrescisaoetapas_insert_submitted', (event, args: IEtapaPontoRescisao) => {
            this.isBusyBtn = false;
            this.NewToaster.pop({
                type: 'success',
                title: 'Tratamento solicitado com sucesso.'
            });
            this.$rootScope.$broadcast('rescisao_ponto_etapa_updated', args);

            if (args && !this.isEmptyObj(args)) {
                this.stepHistory['etapa_' + args.etapa] = args;
                this.step = {
                    etapa: args.etapa,
                    etapadetalhe: args.etapadetalhe,
                };
            }
        });
        this.$scope.$on('meurh_solicitacoesrescisaoetapas_insert_submit_error', () => {
            this.isBusyBtn = false;
            this.NewToaster.pop({
                type: 'error',
                title: 'Ocorreu um erro ao solicitar tratamento.'
            });
        });
        this.$scope.$on('meurh_solicitacoesrescisaoetapas_saldo_loaded', (event, args: ISaldoPontoRescisao) => {
            this.tag = {
                ajustes: args['qtd_ajustes'],
                inconsistencias: args['qtd_inconsistencias'],
            };
            this.syncChecklistState();
        });
    }

    $onInit() {
        this.isBusy = true;
        this.RescisaoPontoService.getEtapa(this.id);
    }

    solicitarTratamento(resend: boolean = false) {
        this.isBusyBtn = true;
        this.RescisaoPontoService.setEtapa(this.id, {
            etapa: 2,
            etapadetalhe: resend ? 2 : 1
        });
    }

    desbloquearParaAlteracoes() {
        const text = {
            title: 'Desbloquear para alterações',
            confirmText: `Esta ação irá desfazer as últimas 3 etapas,
                permitindo que os responsáveis do ponto façam as alterações necessárias.
                Você tem certeza que deseja desbloquear o ponto para alterações?`,
            closeButton: 'Cancelar',
            confirmButton: 'Desbloquear para alterações',
        };
		this.ModalConfirmService.open(null, 'Rescisão', false, text)
            .result.then(() => {
				this.isBusyBtn = true;
                this.RescisaoPontoService.setEtapa(this.id, {
                    etapa: 2,
                    etapadetalhe: 3
                });
			})
			.catch(() => {/**/});
    }

    private setStepHistory(stepList: IEtapaPontoRescisao[]): StepHistory {
        const etapa_1 = stepList.find(step => step.etapa === 1);
        const etapa_2 = stepList.find(step => step.etapa === 2);
        const etapa_3 = stepList.find(step => step.etapa === 3);
        const etapa_4 = stepList.find(step => step.etapa === 4);
        const etapa_5 = stepList.find(step => step.etapa === 5);
        const etapa_6 = stepList.find(step => step.etapa === 6);
        return {
            etapa_1: etapa_1 ? etapa_1 : null,
            etapa_2: etapa_2 ? etapa_2 : null,
            etapa_3: etapa_3 ? etapa_3 : null,
            etapa_4: etapa_4 ? etapa_4 : null,
            etapa_5: etapa_5 ? etapa_5 : null,
            etapa_6: etapa_6 ? etapa_6 : null,
        };
    }

    private setLabel(step: RescisaoPontoEtapa) {
        switch (step) {
            case RescisaoPontoEtapa.ENVIO_PARA_RESPONSAVEL:
                return {
                    class: 'label-info',
                    content: 'Tratamento solicitado'
                };
            case RescisaoPontoEtapa.FINAL:
                return {
                    class: 'label-success',
                    content: 'Tarefas concluídas'
                };
            default:
                return {
                    class: 'label-warning',
                    content: 'Tarefas pendentes'
                };
        }
    }

    private isEmptyObj(obj: object) {
        return Object.keys(obj).length === 0;
    }

    private syncChecklistState() {
        this.showRequestTreatmentAction = this.isCurrentStep(RescisaoPontoEtapa.INICIAL) && !this.hideActions;
        this.showUnlockAction = this.isCurrentStep(RescisaoPontoEtapa.FINAL) && !this.hideActions;
        this.checklistItems = this.montarItensChecklist();
    }

    private montarItensChecklist(): ChecklistItem[] {
        if (!this.step) {
            return [];
        }

        return [
            this.montarItemSolicitarTratamento(),
            this.montarItemTratarPonto(),
            this.montarItemMovimentos(),
            this.montarItemFolhas(),
        ];
    }

    private montarItemSolicitarTratamento(): ChecklistItem {
        const status = this.hasReachedStep(RescisaoPontoEtapa.ENVIO_PARA_RESPONSAVEL) ? 'completed' : 'pending';

        return {
            key: 'request-treatment',
            status,
            iconClass: this.getStatusIconClass(status),
            title: status === 'completed'
                ? 'Tratamento solicitado aos responsáveis'
                : 'Solicitar tratamento aos responsáveis',
            showResendAction: this.isCurrentStep(RescisaoPontoEtapa.ENVIO_PARA_RESPONSAVEL) && !this.hideActions,
        };
    }

    private montarItemTratarPonto(): ChecklistItem {
        const status = this.hasReachedStep(RescisaoPontoEtapa.PONTO_TRATADO) ? 'completed' : 'pending';

        return {
            key: 'point-treatment',
            status,
            iconClass: this.getStatusIconClass(status),
            title: status === 'completed' ? 'Ponto tratado' : 'Tratar ponto',
            showExternalLink: true,
            showTags: status === 'pending' && this.hasPendingTags(),
        };
    }

    private montarItemMovimentos(): ChecklistItem {
        if (this.hasReachedStep(RescisaoPontoEtapa.MOVIMENTOS_GERADOS)) {
            const history = this.getStepHistory(RescisaoPontoEtapa.MOVIMENTOS_GERADOS);
            const hasMovements = history ? history.etapadetalhe === 1 : true;

            return {
                key: 'movements',
                status: 'completed',
                iconClass: this.getStatusIconClass('completed'),
                title: hasMovements ? 'Movimentos de ponto gerados' : 'Movimentos de ponto',
                subtitle: hasMovements
                    ? 'Os movimentos de ponto foram gerados e podem ser aprovados ou recusados na tabela de movimentos ao lado.'
                    : 'Não existem movimentos a serem gerados para esse colaborador.',
                hint: hasMovements && !this.hideActions
                    ? 'Para realizar essa ação, clique em "Editar" na parte superior da tela.'
                    : undefined,
            };
        }

        if (this.isCurrentStep(RescisaoPontoEtapa.PONTO_TRATADO)) {
            return {
                key: 'movements',
                status: 'active',
                iconClass: this.getStatusIconClass('active'),
                title: 'Gerando movimentos de ponto',
            };
        }

        return {
            key: 'movements',
            status: 'pending',
            iconClass: this.getStatusIconClass('pending'),
            title: 'Gerar movimentos de ponto',
        };
    }

    private montarItemFolhas(): ChecklistItem {
        if (this.hasReachedStep(RescisaoPontoEtapa.FOLHAS_GERADAS)) {
            const history = this.getStepHistory(RescisaoPontoEtapa.FOLHAS_GERADAS);
            const hasFolhas = history ? history.etapadetalhe === 1 : true;

            return {
                key: 'folhas',
                status: 'completed',
                iconClass: this.getStatusIconClass('completed'),
                title: hasFolhas ? 'Folhas de ponto geradas' : 'Folhas de ponto',
                subtitle: hasFolhas
                    ? undefined
                    : 'Não existem folhas a serem geradas para esse colaborador.',
            };
        }

        if (this.isCurrentStep(RescisaoPontoEtapa.MOVIMENTOS_GERADOS)) {
            return {
                key: 'folhas',
                status: 'active',
                iconClass: this.getStatusIconClass('active'),
                title: 'Gerando folhas de ponto',
            };
        }

        return {
            key: 'folhas',
            status: 'pending',
            iconClass: this.getStatusIconClass('pending'),
            title: 'Gerar folhas de ponto',
        };
    }

    private shouldLoadSaldo(step: RescisaoPontoEtapa) {
        return this.getFlowIndex(step) < this.getFlowIndex(RescisaoPontoEtapa.PONTO_TRATADO);
    }

    private hasReachedStep(targetStep: RescisaoPontoEtapa) {
        if (!this.step) {
            return false;
        }

        return this.getFlowIndex(this.step.etapa) >= this.getFlowIndex(targetStep);
    }

    private isCurrentStep(targetStep: RescisaoPontoEtapa) {
        return !!this.step && this.step.etapa === targetStep;
    }

    private hasPendingTags() {
        return this.tag.ajustes > 0 || this.tag.inconsistencias > 0;
    }

    private getStepHistory(step: RescisaoPontoEtapa) {
        return this.stepHistory['etapa_' + step];
    }

    private getFlowIndex(step: RescisaoPontoEtapa) {
        // o fluxo segue a ordem numerica: 1 -> 2 -> 3 -> 5 -> 4 -> 6.
        // a etapa 5 continua sendo movimentos e a etapa 4 continua sendo folhas.
        return [
            RescisaoPontoEtapa.INICIAL,
            RescisaoPontoEtapa.ENVIO_PARA_RESPONSAVEL,
            RescisaoPontoEtapa.PONTO_TRATADO,
            RescisaoPontoEtapa.MOVIMENTOS_GERADOS,
            RescisaoPontoEtapa.FOLHAS_GERADAS,
            RescisaoPontoEtapa.FINAL,
        ].indexOf(step);
    }

    private getStatusIconClass(status: ChecklistStatus) {
        switch (status) {
            case 'active':
                return 'fas fa-spinner icon-primary';
            case 'completed':
                return 'fas fa-check icon-success';
            default:
                return 'fas fa-times icon-default';
        }
    }

    private createEmptyStepHistory(): StepHistory {
        return {
            etapa_1: null,
            etapa_2: null,
            etapa_3: null,
            etapa_4: null,
            etapa_5: null,
            etapa_6: null,
        };
    }
}
